import { Dialog, DialogContent } from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
  svgElement: SVGSVGElement | null;
};

export function TLLabelViewerModal({ open, onClose, svgElement }: Props) {
  return (
    <Dialog open={open} onClose={onClose} sx={{ scale: 2 }}>
      <DialogContent>
        <div
          style={{ width: "100%", height: "auto", overflow: "auto" }}
          ref={(el) => {
            if (el && svgElement) {
              el.innerHTML = "";
              el.appendChild(svgElement.cloneNode(true));
            }
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
